module.exports = "<div id=\"facebook-login\" ng-hide=\"config.currentState == 'completeProfile'\">\n\t<button class=\"btn-block icon-center\" ng-click=\"facebook()\" ng-bs-animated-button=\"\" is-submitting=\"loginFbSubmitting\" result=\"loginFbResult\" options=\"loginFbBtnOptions\"></button>\n\t<p class=\"error\" ng-show=\"facebookError\">{{ facebookError }}</p>\n\t<div class=\"or-container\">\n\t\t<div class=\"or\" ng-show=\"config.compactLayout\">OR</div>\n\t</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/loginFacebook/template.html
// module id = 857
// module chunks = 1